import Vue from 'vue'
import Vuex from 'vuex'
import login from '@/components/login/login.js';
import { sysConfigs_stadiumConfig } from '@/apis/user'

Vue.use(Vuex)


/* 獲取系統配置 */
async function getSystemConfig() {
    try {
        const res = await sysConfigs_stadiumConfig();
        if (res.code == 0) {
            const config = res.data;
            return config;
        }
    } catch (error) {

    }

    // const systemConfigJson = localStorage.getItem('systemConfig');
    // if (systemConfigJson) {
    //     const config = JSON.parse(systemConfigJson);
    //     return config;
    // } else {
    //     const res = await sysConfigs_stadiumConfig();
    //     if (res.code == 0) {
    //         const config = res.data;
    //         localStorage.setItem('systemConfig', JSON.stringify(config));
    //         return config;
    //     }
    // }
}


export default new Vuex.Store({
    state: {
        userId: localStorage.getItem('userId') || '',
        token: localStorage.getItem('token') || '',
        refreshToken: localStorage.getItem('refreshToken') || '',
        breadcrumb: localStorage.getItem('breadcrumb') || '',
        insidehead: localStorage.getItem('insidehead') || '',
        systemConfig: await getSystemConfig() || []
    },
    mutations: {
        // refresh token
        UPDATE_TOKEN(state, token) {
            state.token = token
            localStorage.setItem('token', token)
        },
        // set tokens
        SET_TOKENS(state, { token, refreshToken }) {
            state.token = token
            state.refreshToken = refreshToken
            localStorage.setItem('token', token)
            localStorage.setItem('refreshToken', refreshToken)
        },
        // clear token
        CLEAR_TOKENS(state) {
            state.token = ''
            state.refreshToken = ''
            localStorage.removeItem('token')
            localStorage.removeItem('refreshToken')
        },
        SET_USERID(state, userId) {
            state.userId = userId;
            localStorage.setItem('userId', userId)
        },
        //寫入麵包屑
        SET_BREADCRUMB(state, breadcrumb) {
            state.breadcrumb = breadcrumb;
            localStorage.setItem('breadcrumb', breadcrumb)
        },
        //內頁的頂部圖片路徑
        SET_INSIDEHEAD(state, insidehead) {
            state.insidehead = insidehead;
            localStorage.setItem('insidehead', insidehead)
        }
    },
    actions: {
        logout({ commit }) {
            commit('CLEAR_TOKENS')
            //login.open();
            location.reload();
            // 跳轉至登錄頁
            //location.href = '/login';
        }
    }
})